require('../../modules/es6.string.includes');
module.exports = require('../../modules/_core').String.includes;



//////////////////
// WEBPACK FOOTER
// /builds/intothesource/vadain/stalenservice-without-login/node_modules/core-js/fn/string/includes.js
// module id = 76
// module chunks = 13